import type { ContentPage } from "@/lib/content/types";

export const salesBlueprint: ContentPage = {
  slug: "process-management/sales-blueprint",
  template: "hrmsFeature",
  seo: {
    title: "Sales Blueprint Software - Guide Every Deal to Close | GetBiz CRM",
    description:
      "Design a step-by-step sales blueprint in GetBiz CRM that guides reps through every stage, enforces the right actions, and makes your best process repeatable.",
    keywords: [
      "sales blueprint software",
      "sales process builder",
      "guided selling",
      "sales playbook software",
      "CRM blueprint",
      "process automation",
    ],
    ogImage: "/assets/data/seoimages/sales-blueprint.webp",
  },
  leaf: {
    hero: {
      caption: "Sales Blueprint",
      title: "Turn Your Best Sales Process Into a Repeatable Playbook",
      description:
        "Design a visual, step-by-step blueprint that guides every rep through the right stages and actions — so your winning process runs the same way every time.",
      h1: "caption",
    },
    split: {
      title: "Guided Selling, Built In",
      bullets: [
        { title: "Visual Builder", description: "Drag-and-drop your stages and transitions with no code." },
        { title: "Mandatory Steps", description: "Enforce the actions that must happen before a deal moves." },
        { title: "Guided Prompts", description: "Tell reps exactly what to do at each stage." },
        { title: "Consistency", description: "Every rep follows the same proven playbook." },
      ],
      image: "/assets/images/img/product/crm/guided-selling-image.webp",
      imageAlt: "GetBiz CRM sales blueprint builder",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Sales Blueprint works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Approval Process", href: "/crm-software/process-management/approval-process/", description: "Automate multi-level approvals within your blueprint.", image: "/assets/images/img/product/crm/approval-process.webp", imageAlt: "CRM approval process" },
      { title: "Assignment Rule", href: "/crm-software/process-management/assignment-rule/", description: "Route records to the right owner at each stage.", image: "/assets/images/img/product/crm/assignment-rule.webp", imageAlt: "CRM assignment rule" },
      { title: "Validation Rule", href: "/crm-software/process-management/validation-rule/", description: "Keep data clean as deals progress.", image: "/assets/images/img/product/crm/validation-rule.webp", imageAlt: "CRM validation rule" },
      { title: "Review Process", href: "/crm-software/process-management/review-process/", description: "Add QA and review checkpoints between stages.", image: "/assets/images/img/product/crm/review-process.webp", imageAlt: "CRM review process" },
    ],
    testimonials: { title: "A repeatable process that scales", description: "See why teams build their playbook in GetBiz CRM." },
    bookDemoTitle: "Build your winning sales blueprint.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "what-is-a-sales-blueprint, sales-blueprint-best-practices",
    metaKey: "sales-blueprint",
  },
  sections: [],
};
